import useInvoices from "@/lib/queries/user/useInvoices";
import Invoice from "./Invoice";
import useUser from "@/lib/queries/user/useUser";
import Loading from "./Loading";
import { useStytchSession } from "@stytch/react";

const Invoices = () => {
  const stytchSession = useStytchSession();
  const { data } = useUser({
    enabled: stytchSession.session !== null,
  });
  const invoices = useInvoices(data?.stripeCustomerId ?? "", {
    options: {
      enabled: !!stytchSession.session && !stytchSession.fromCache,
    },
  });

  if (invoices.isLoading) {
    return <Loading />;
  }

  return (
    <div className="flex flex-col w-full gap-2 pt-6 pl-6 pr-6 bg-background">
      <h1 className="mb-4 text-4xl font-semibold">Billing</h1>
      {invoices.data?.map((invoice) => (
        <Invoice key={invoice.id} invoice={invoice} />
      ))}
      {invoices.data?.length === 0 && (
        <div className="flex items-center justify-center h-96">
          <p className="text-gray-500">No invoices found</p>
        </div>
      )}
    </div>
  );
};

export default Invoices;
